import React from 'react';
import { cn } from '../../lib/utils';

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  intensity?: 'light' | 'medium' | 'dark';
  variant?: 'default' | 'subtle' | 'outline' | 'solid';
  hover?: boolean;
}

export const GlassCard = ({ 
  children, 
  className = '', 
  variant = 'default',
  intensity = 'medium',
  hover = false,
  style,
  ...props 
}: GlassCardProps) => {
  const intensities = {
    light: { opacity: '0.6', blur: '8px' },
    medium: { opacity: 'var(--glass-opacity, 0.8)', blur: 'var(--glass-blur, 16px)' },
    dark: { opacity: '0.95', blur: '24px' }
  };

  const variants = {
    default: "bg-white/[var(--card-opacity)] border-white/10",
    subtle: "bg-white/0 border-transparent shadow-none",
    outline: "bg-transparent border-brand-primary/30",
    solid: "bg-brand-surface border-white/5 shadow-premium"
  };

  return (
    <div 
      className={cn(
        "relative overflow-hidden transition-all duration-500 border",
        hover && "hover:scale-[1.01] hover:border-white/20 hover:shadow-premium cursor-pointer",
        variants[variant],
        className
      )}
      style={{ 
        '--card-opacity': intensities[intensity].opacity,
        borderRadius: 'var(--brand-radius, 1.5rem)',
        backdropFilter: `blur(${intensities[intensity].blur})`,
        ...style 
      } as React.CSSProperties}
      {...props}
    >
      {children}
    </div>
  );
};
